<div class="item" [hidden]="!pageStatus.error">
	<div [ngSwitch]="pageStatus.errorType" class="centered-text-block video-playback-status-msg video-playback-error-msg">
		<h3 *ngSwitchCase="'ResourceNotFound'" class="centered-text-block-content">
			<span class="glyphicons warning_sign"></span>
			{{ 'Video_Playback_VideoNotFound' | translate }}
		</h3>
		<h3 *ngSwitchDefault class="centered-text-block-content">
			<span class="glyphicons warning_sign"></span>
			{{ 'UnhandledError' | translate }}
		</h3>
	</div>
</div>

<div class="item" [hidden]="(!pageStatus.active && !pageStatus.loading) || playableStatus === VideoStatus.READY">

	<div [ngSwitch]="playableStatus" class="centered-text-block video-playback-status-msg" [hidden]="pageStatus.loading">

		<div *ngSwitchCase="'ProcessingFailed'" class="centered-text-block-content video-playback-error-msg">
			<h3 *ngIf="!showRestoreBtn">
				<span class="glyphicons warning_sign"></span>
				{{ 'Video_Playback_VideoProcessingFailed' | translate }}
			</h3>
			<ng-container *ngIf="showRestoreBtn">
				<h3>
					<span class="glyphicons warning_sign"></span>
					{{ 'Media_Playback_VideoProcessingFailedWithRevert' | translate }}
				</h3>
				<button type="button" class="restore-button" (click)="onRevert()" vbBtnPrimary>
					{{ 'Media_Videos_Replace_RevertMessage' | translate }}
				</button>
			</ng-container>
		</div>

		<h3 *ngSwitchCase="playableStatus === 'UploadFailed' || playableStatus === 'UploadingFailed'" class="centered-text-block-content video-playback-error-msg">
			<span class="glyphicons warning_sign"></span>
			{{ 'Video_Playback_VideoUploadingFailed' | translate }}
		</h3>

		<h3 *ngSwitchCase="'Processing'" class="centered-text-block-content">
			<vb-loading-spinner [block]="true" [iconClass]="'vb-icon vb-icon-camera-plus'" [msg]="'Video_Playback_VideoProcessing' | translate" [msgDisplayBelowSpinner]="true" [size]="'large'">
			</vb-loading-spinner>
		</h3>

		<h3 *ngSwitchCase="'Uploading'" class="centered-text-block-content">
			<vb-loading-spinner [block]="true" [iconClass]="'vb-icon vb-icon-cloud-upload'" [msg]="'Video_Playback_VideoUploading' | translate" [msgDisplayBelowSpinner]="true" [size]="'large'">
			</vb-loading-spinner>
		</h3>

		<h3 *ngSwitchCase="'DeviceNotSupported'" class="centered-text-block-content video-playback-error-msg">
			<span class="glyphicons warning_sign"></span>
			{{ 'Video_Playback_BrowserNotSupported' | translate }}
		</h3>

		<h3 *ngSwitchCase="'DownloadFailed'" class="centered-text-block-content video-playback-error-msg">
			<span class="glyphicons warning_sign"></span>
			{{ 'Video_Playback_DownloadVideoFailed' | translate }}
		</h3>

		<h3 *ngSwitchCase="'ViewingHoursNotAvailable'" class="centered-text-block-content video-playback-error-msg">
			<span class="glyphicons warning_sign"></span>
			{{ 'Video_Playback_ViewingHoursNotAvailable' | translate }}
		</h3>
	</div>

	<vb-loading-spinner [block]="true" [size]="'medium'" [hidden]="!pageStatus.loading">
	</vb-loading-spinner>

	<div [hidden]="!pageStatus.active || playableStatus" class="centered-text-block video-playback-status-msg">
		<h3 class="centered-text-block-content video-playback-error-msg">
			<span class="glyphicons warning_sign"></span>
			{{ 'UnhandledError' | translate }}
		</h3>
	</div>

</div>
